import { AbstractAuthProvider } from "../../auth/services";

/**
 * @class ApiAuthProvider
 * @extends AbstractAuthProvider<User, Token, {email: string, password: string}, {user: User, toke: Token}>
 */
export class AuthProvider extends AbstractAuthProvider {

    static get $inject() {

        return [ 'AuthAccessPmsApiService', 'AuthUserPmsApiService', '$uibModal'];
    }

    /**
     * @param {AuthAccessPmsApiService} AuthAccessPmsApiService
     * @param {AuthUserPmsApiService} AuthUserPmsApiService
     */
    constructor(AuthAccessPmsApiService, AuthUserPmsApiService) {

        super();

        this.AuthAccessPmsApiService = AuthAccessPmsApiService;
        this.AuthUserPmsApiService = AuthUserPmsApiService;
    }

    /**
     * @param {Token} identifier
     * @returns {Promise<User>}
     */
    user(identifier) {

        return this.AuthUserPmsApiService.get();
    }

    /**
     * @param {{email: string, password: string, remember: boolean, isBilling: boolean}} credentials
     * @returns {Promise<{user: User, token: Token}>}
     */
    request({email, password, remember, isBilling}) {

        return this.AuthAccessPmsApiService
                   .request(email, password, remember, isBilling)
                   .then(({user, token,otp_required, otp_sent}) => {

                       return {
                           user,
                           identifier: token,
                           otp_required,
                           otp_sent
                       };
                    
                   });
    }

    /**
     * @returns {Promise<{identifier: Token}>}
     */
    refreshToken() {
        
        return this.AuthAccessPmsApiService
                   .refresh()
                   .then(({token}) => {
                       
                       return {
                           identifier: token
                       };
                   });
    }

    requestBillingPortalAuth() {

        return this.AuthAccessPmsApiService
            .requestBillingPortalAuth()
            .then(({user, token}) => {

                return {
                    user,
                    identifier: token
                };
            });
    }

    /**
     * @param {Object} params
     * @returns {Promise<boolean>}
     */
    revoke(params) {

        return this.AuthAccessPmsApiService.revoke(params);
    }

    verifyOtp(code, token) {
        return this.AuthAccessPmsApiService.verifyOtp(code, token);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/authProvider.service.js